<template>
  <van-popup v-model="showReplyField" position="bottom">
    <div :class="$style.box">
      <div :class="$style.top">
        <img :src="backImage" @click="showReplyField = false" />
        <button @click.stop="sendMsg">{{ '发送' }}</button>
      </div>
      <!-- 中部文本输入框 -->
      <div
        :class="$style.textarea"
        contenteditable="plaintext-only"
        ref="editor"
        @keyup="limitContext"
      ></div>
      <!-- 上传图片列表（单独区域） -->
      <ul v-if="hasImgList" :class="$style.imgList">
        <li
          v-for="(item, index) in imgList"
          :key="index"
          :class="index && index % 4 === 0 && $style.nomargin"
        >
          <img :src="item" />
          <i class="iconfont yw-guanbi1" @click="deleteImg(index)"></i>
        </li>
      </ul>
      <div :class="$style.footer">
        <img v-if="isFirstReply" :src="blackcat_icon" alt="表情icon" @click="chooseEmoji" />
        <img v-if="isFirstReply" :src="photo_icon" alt="图片icon" @click="insertImage" />
        <!-- 字数限制 -->
        <span :class="`${$style.count} ${overLimit && $style.active}`"
          >{{ textLen }}/{{ textLimit }}</span
        >
      </div>
      <EmojiSelector
        v-if="emojiSelectorShow && isFirstReply"
        @close="emojiSelectorShow = false"
        @selectEmoji="insertSelectEmoji"
        :class="`${$style.emoji} ${emojiSelectorShow && $style.active}`"
        style="padding: 0"
      ></EmojiSelector>
    </div>
  </van-popup>
</template>

<script>
import EmojiSelector from '@/components/EmojiSelector';
import UploadMixin from '@/mixins/uploadImage';
import { Popup, Toast, Dialog } from 'vant';
import { submitReply } from '@/api/gameCircle';
import { reportData } from '@/api/report';
import { mapActions, mapState, mapMutations } from 'vuex';
import { CDN_URL } from '@/config/index.js';
export default {
  components: {
    VanPopup: Popup,
    EmojiSelector,
  },
  mixins: [UploadMixin],
  props: {
    isFirstReply: {
      type: Boolean,
      default: false,
    },
    // 一级回复commentId可不传 ; 二级回复的commentId:一级回复id; 三级回复的commentId:二级回复id
    commentId: {
      type: [Number, String],
      default: 0,
    },
  },
  data() {
    return {
      showReplyField: true,
      backImage: `${CDN_URL}/back.png`, // 回复输入框返回按钮
      blackcat_icon: `${CDN_URL}/logo_1.png`, // 回复输入框底部黑喵小图标
      photo_icon: `${CDN_URL}/photo.png`, // 回复输入框底部图片小图标
      textLimit: 300, // 最大字数限制
      textLen: 0, // 字数
      overLimit: false, // 是否超过最大字数
      emojiSelectorShow: false, // 是否显示表情选择
      fieldHeight: '', // 弹窗高度
      imgList: [], // 上传图片列表
      brushFlag: false, // 防重复提交回复
      textContent: '',
    };
  },
  computed: {
    ...mapState('account', {
      userInfo: (state) => state.userInfo, // 当前用户信息
    }),
    // 游戏圈id
    circleId() {
      return this.$route.query.circleId;
    },
    // 帖子id
    conversationId() {
      return this.$route.query.id;
    },
    hasImgList() {
      return this.imgList.length > 0 ? true : false;
    },
    // editorContent() {
    //   return this.$refs.editor && this.$refs.editor.innerHTML;
    // },
  },
  mounted() {
    reportData({
      type: 5,
      data_type: 6,
      circle_id: this.circleId,
      conversation_id: this.conversationId,
    });
  },
  watch: {
    showReplyField(newValue) {
      if (!newValue) {
        this.$emit('closeReplyField');
      }
    },
  },
  methods: {
    ...mapActions('account', {
      getUserInfo: 'getUserInfo',
    }),
    // 获取文本光标
    getTextCursor() {
      this.textCursor = window.getSelection().getRangeAt(0);
    },
    // 点击表情图标打开表情选择器
    chooseEmoji() {
      reportData({
        type: 5,
        data_type: 8,
        circle_id: this.circleId,
        conversation_id: this.conversationId,
      });
      this.emojiSelectorShow = !this.emojiSelectorShow;
      this.$refs.editor.blur();
    },
    // 将选择的表情插入到编辑器中
    insertSelectEmoji(emojiName) {
      let div = document.createElement('div');
      div.innerHTML = `<img src=${CDN_URL}/emoji/${emojiName}.png class="hm-emoji">`;
      let el = div.children[0];
      if (this.textCursor) {
        // 将表情图片插入到失去焦点前光标位置
        this.textCursor.insertNode(el);
        // 通过将新加dom加入range文本块后折叠到最后的方式，改变光标位置到新增表情后面 否则插入顺序会变反
        this.textCursor.selectNode(el);
        this.textCursor.collapse();
      } else {
        // 首次直接添加表情到编辑器最后面
        this.$refs.editor.appendChild(el);
      }
    },
    // 将图片插入dom树中
    addImgToDom(src) {
      this.imgList.push(src);
    },
    // 点击插入选择图片按钮
    insertImage() {
      reportData({
        type: 5,
        data_type: 9,
        circle_id: this.circleId,
        conversation_id: this.conversationId,
      });
      this.emojiSelectorShow = false;
      this.imgList = [];
      this.uploadImage(3, true);
    },
    // 删除图片
    deleteImg(index) {
      this.imgList.splice(index, 1);
    },
    // 限制字数
    limitContext(e) {
      let _html = this.$refs.editor.innerText;
      this.textLen = _html.length;
      if (this.textLen > this.textLimit) {
        this.overLimit = true;
      } else {
        this.overLimit = false;
      }
    },
    // 发表回复
    async sendMsg() {
      await this.getUserInfo();
      let prohibition = this.userInfo.prohibition;
      if (prohibition.state_type == 3) {
        let warnMsg = `您已被禁言\n 禁言时间：${
          prohibition.time_type == 1 ? '永久' : prohibition.start_time + '~' + prohibition.end_time
        }`;
        Dialog.alert({
          title: '温馨提示',
          message: warnMsg,
        }).then(() => {});
        return;
      }
      reportData({
        type: 5,
        data_type: 7,
        circle_id: this.circleId,
        conversation_id: this.conversationId,
      });
      // upLoadImgFlag: 判断图片是否正在上传，brushFlag：防止重复提交
      if (this.upLoadImgFlag || this.brushFlag) return;
      this.textContent = this.$refs.editor && this.$refs.editor.innerHTML;
      if (!this.textContent.length && !this.imgList.length) {
        Toast('回复内容不能为空');
        return;
      }
      if (this.overLimit) {
        Toast('内容超出最大限制');
        return;
      }
      if (this.textContent.trim().length == 0 && !this.imgList.length) {
        Toast('表达你的态度再评论吧');
        return;
      }
      this.brushFlag = true;
      try {
        let content = {
          imgList: this.imgList,
          text: this.textContent,
          emoji: this.$refs.editor.getElementsByClassName('hm-emoji').length > 0 ? true : false,
        };
        let data = {
          conversation_id: this.conversationId,
          comment_id: this.commentId,
          content: JSON.stringify(content),
        };
        try {
          const r = await submitReply(data);
          Toast('评论成功');
          this.$emit('refreshList');
        } catch (error) {
          console.log(error);
          // 2021.01.18新增 超过回复次数限制需要验证码
          if (error.code === 999) {
            this.$emit('getCaptcha', data);
          }
        }
      } finally {
        this.showReplyField = false;
        this.brushFlag = false;
      }
    },
  },
};
</script>

<style lang='scss' module>
@import '~@/styles/mixins.scss';
.box {
  padding: 7px 7px 20px 7px;
}
.top {
  width: 361px;
  height: 26px;
  margin-bottom: 7px;
  > img {
    width: 15px;
    float: left;
    margin-top: 6px;
  }
  > button {
    @include clearBtnDefaultStyle;
    width: 51px;
    line-height: 26px;
    background: rgba(69, 175, 243, 1);
    border-radius: 13px;
    text-align: center;
    color: white;
    float: right;
    font-size: 10px;
    font-weight: 400;
  }
}
.textarea {
  width: 361px;
  height: 100px;
  outline: none;
  padding: 10px;
  line-height: 18px;
  background: rgba(243, 244, 248, 1);
  border-radius: 7px;
  overflow: auto;
  :global {
    .hm-emoji {
      vertical-align: bottom;
    }
  }
}
.imgList {
  margin: 10px auto;
  width: 100%;
  height: 70px;
  li {
    position: relative;
    margin-right: 5px;
    margin-bottom: 5px;
    display: inline-block;
    &.nomargin {
      margin: 0;
    }
    :global {
      .yw-guanbi1 {
        position: absolute;
        top: 0;
        right: 0;
        width: 15px;
        height: 15px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.6);
        color: #ffffff;
        font-size: 10px;
      }
    }
  }
  img {
    width: 64px;
    height: 64px;
  }
}
.footer {
  left: 0;
  width: 100%;
  height: 44px;
  line-height: 44px;
  padding: 0 15px;
  background: #ffffff;
  z-index: 10;
  > img {
    margin-top: 15px;
    width: 18px;
    float: left;
    margin-right: 18px;
  }
  .count {
    float: right;
  }
  .emoji {
    position: absolute;
    bottom: -200px;
    left: 0;
    &.active {
      bottom: 44px;
    }
  }
}
</style>